import { EyeIcon, EyeOffIcon } from 'lucide-react';
import * as React from 'react';

import { cn } from '../lib/utils';

import { Button } from './button';
import { Input } from './input';

interface PasswordInputProps extends Omit<React.ComponentProps<typeof Input>, 'type'> {
  /** Accessible name of the toggle while the value is hidden. */
  showLabel?: string;
  /** Accessible name of the toggle while the value is visible. */
  hideLabel?: string;
}

/** A password (or secret) input with an eye button that reveals the value. */
function PasswordInput({
  className,
  disabled,
  showLabel = 'Show password',
  hideLabel = 'Hide password',
  ...props
}: PasswordInputProps) {
  const [visible, setVisible] = React.useState(false);
  return (
    <div data-slot="password-input" className="relative">
      <Input
        {...props}
        type={visible ? 'text' : 'password'}
        disabled={disabled}
        className={cn('pr-10', className)}
      />
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        className="text-muted-foreground hover:text-foreground absolute top-1/2 right-1 -translate-y-1/2"
        disabled={disabled}
        aria-label={visible ? hideLabel : showLabel}
        aria-pressed={visible}
        onClick={() => setVisible((v) => !v)}
      >
        {visible ? <EyeOffIcon aria-hidden /> : <EyeIcon aria-hidden />}
      </Button>
    </div>
  );
}

export { PasswordInput, type PasswordInputProps };
